/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAaa_contactUsFormViewProps } from './aaa_contact-us-form';
import { Button } from '@msdyn365-commerce-modules/utilities';

export default (props: IAaa_contactUsFormViewProps) => {
    return (
        <form>
            <div className={'ms-business-sign-up__form '}>
                <div className='ms-business-sign-up__form-item ms-business-sign-up__form-item-BoutiqueName width-50'>
                    <label id='Boutique_Name_label' className='ms-business-sign-up__form-item-label' htmlFor='Boutique Name'>
                        Boutique Name *
                    </label>
                    <div className='ms-business-sign-up__form-item__item-error error itemLevel'>
                        <input
                            id={'boutiqueName'}
                            type={'text'}
                            value={props.state.boutiqueName}
                            placeholder={'Boutique Name'}
                            className={`ms-business-sign-up__form-item-input ms-business-sign-up__form-item-BoutiqueName`}
                            aria-required={true}
                            onChange={(e: any) => props.setFromField('boutiqueName', e.target.value)}
                        />
                    </div>
                </div>
                <div className='ms-business-sign-up__form-item ms-business-sign-up__form-item-BoutiqueLocation width-50'>
                    <label id='BoutiqueLocation_label' className='ms-business-sign-up__form-item-label' htmlFor='BoutiqueLocation'>
                        Boutique Location *
                    </label>
                    <div className='ms-business-sign-up__form-item__item-error error itemLevel'>
                        <input
                            id={'boutiqueLocation'}
                            type={'text'}
                            value={props.state.lastName}
                            placeholder={'Boutique Location'}
                            className={`ms-business-sign-up__form-item-input ms-business-sign-up__form-item-BoutiqueLocation`}
                            aria-required={true}
                            onChange={(e: any) => props.setFromField('boutiqueLocation', e.target.value)}
                        />
                    </div>
                </div>
                <div className='ms-business-sign-up__form-item ms-business-sign-up__form-item-FirstName width-50'>
                    <label id='FirstName_label' className='ms-business-sign-up__form-item-label' htmlFor='FirstName'>
                        First Name *
                    </label>
                    <div className='ms-business-sign-up__form-item__item-error error itemLevel'>
                        <input
                            id={'firstName'}
                            type={'text'}
                            value={props.state.firstName}
                            placeholder={'First Name'}
                            className={`ms-business-sign-up__form-item-input ms-business-sign-up__form-item-FirstName`}
                            aria-required={true}
                            onChange={(e: any) => props.setFromField('firstName', e.target.value)}
                        />
                    </div>
                </div>
                <div className='ms-business-sign-up__form-item ms-business-sign-up__form-item-LastName width-50'>
                    <label id='LastName_label' className='ms-business-sign-up__form-item-label' htmlFor='LastName'>
                        Last Name *
                    </label>
                    <div className='ms-business-sign-up__form-item__item-error error itemLevel'>
                        <input
                            id={'lastName'}
                            type={'text'}
                            value={props.state.lastName}
                            placeholder={'Last Name'}
                            className={`ms-business-sign-up__form-item-input ms-business-sign-up__form-item-LastName`}
                            aria-required={true}
                            onChange={(e: any) => props.setFromField('lastName', e.target.value)}
                        />
                    </div>
                </div>
                <div className='ms-business-sign-up__form-item ms-business-sign-up__form-item-EmailAddress width-50'>
                    <label id='EmailAddress_label' className='ms-business-sign-up__form-item-label' htmlFor='EmailAddress'>
                        Email Address *
                    </label>
                    <div className='ms-business-sign-up__form-item__item-error error itemLevel'>
                        <input
                            id={'emailAddress'}
                            type={'email'}
                            value={props.state.email}
                            placeholder={'Email Address'}
                            className={`ms-business-sign-up__form-item-input ms-business-sign-up__form-item-EmailAddress`}
                            aria-required={true}
                            onChange={(e: any) => props.setFromField('email', e.target.value)}
                        />
                    </div>
                </div>
                <div className='ms-business-sign-up__form-item ms-business-sign-up__form-item-Phone width-50'>
                    <label id='EmailAddress_label' className='ms-business-sign-up__form-item-label' htmlFor='Contact Number'>
                        Contact Number *
                    </label>
                    <div className='ms-business-sign-up__form-item__item-error error itemLevel'>
                        <input
                            id={'contactNumber'}
                            type={'text'}
                            value={props.state.phone}
                            placeholder={'Contact Number'}
                            className={`ms-business-sign-up__form-item-input ms-business-sign-up__form-item-phone`}
                            aria-required={true}
                            onChange={(e: any) => props.setFromField('phone', e.target.value)}
                        />
                    </div>
                </div>
                <div className='ms-business-sign-up__form-item ms-business-sign-up__form-item-Comment width-100'>
                    <label id='Comments_label' className='ms-business-sign-up__form-item-label' htmlFor='Comments'>
                        Comments *
                    </label>
                    <textarea
                        id={'Comments'}
                        name={'Comments'}
                        value={props.state.description}
                        className={'ms-business-sign-up__form-item-input-area ms-business-sign-up__form-item-Comment'}
                        aria-required={false}
                        onChange={(e: any) => props.setFromField('description', e.target.value)}
                    />
                </div>
            </div>
            <Button
                id={'ContactUs'}
                className={'ms-business-sign-up__create-button msc-btn'}
                aria-label={'Contact Us'}
                role='button'
                onClick={() => props.onSubmit()}
                disabled={!props.state.email}
            >
                {'Submit'}
            </Button>
        </form>
    );
};
